import React from "react";
import classnames from "classnames";

import _str from "shared/util/_str";
import Actions from "okpay/actions/Actions";
import TextInput from "okpay/util/TextInput";

class Expiration extends React.Component {
	lastValue = "";

	_fixValue = (_value) => {
		/*
		what we do:
		(1) strip whitespace
		(2) check length right now
		(3) strip all non-digits
		(4) if length was greater than 2 (so there are 3 digits, or there are
		two digits and a slash), insert the separator
		*/

		// if they went from going having " / " to having " /",
		// they're backspacing
		// so skip that shit and clear the sep
		const fullSeparator = /\s\/\s$/;
		const backspacedSeparator = /\s\/$/;

		let value = _value;

		if (
			this.lastValue.match(fullSeparator) &&
			value.match(backspacedSeparator)
		) {
			value = value.replace(/\D/gi, "");
		} else {
			value = value.replace(/\s/gi, "");
			const lengthWithNonDigits = value.length;
			value = value.replace(/\D/gi, "");

			// limit to 4 digits
			value = value.substr(0, 4);
			const lengthWithoutNonDigits = value.length;

			const hasNonDigits = lengthWithNonDigits > lengthWithoutNonDigits;

			// if they have one number and a non-digit, prepend a 0
			if (lengthWithoutNonDigits === 1 && hasNonDigits) {
				value = `0${value}`;
			}

			// if they have at least two digits, and they have three total chars,
			// they're good for a sep
			if (lengthWithoutNonDigits >= 2 && lengthWithNonDigits > 2) {
				value = value.split("");
				value.splice(2, 0, " / ");
				value = value.join("");
			}
		}

		return value;
	};

	_onChange = (e) => {
		const value = this._fixValue(e.target.value);

		if (value !== e.target.value) {
			e.target.value = value;
		}

		this.lastValue = value;

		Actions.updateField({ expiration: value });
	};

	render() {
		const classes = classnames({
			"okpay-item": true,
			"okpay-item-expiration": true,
		});

		return (
			<div className={classes}>
				<div className="okpay-item-element">
					<TextInput
						value={this.props.value}
						name="expiration"
						label={_str("Expiration")}
						autoComplete="on"
						placeholder={_str("MM / YY")}
						onChange={this._onChange}
					/>
				</div>
			</div>
		);
	}
}

export default Expiration;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/fields/Expiration.jsx